<input type="text" [value]="value" #input style="width: 100%; background: #fcf3f3; border-width: 0px"
       [maxLength]="inputMaxLength">
